import { useMemo } from 'react';
import { allModals } from 'src/modals';
import { useRedux, modalParams } from 'src/hooks/useRedux';

export const ModalsContainer = () => {
  const { modals } = useRedux();

  const ActiveModals = useMemo(() => Object.keys(modals).map((k => {
      const ModalComponent = allModals[k];

      return <ModalComponent key={k} {...modalParams[k]} />
    })), [modals])

  return <>{ActiveModals}</>;
}